function on(eventType, listener) {
  document.addEventListener(eventType, listener);
}

function sendEvent(eventType, data) {
  const event = new CustomEvent(eventType, { detail: data });
  document.dispatchEvent(event);
}

export { on, sendEvent };